/* eslint-disable react/no-danger */
import React, { useCallback } from 'react'
import QRCode from 'react-qr-code'
import { shallowEqual, useSelector } from 'react-redux'
import { useModalContext } from '@bcraft-frontend-lib/core'
import { CryptoDeposit } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { selectLocaleDict } from 'features/locale/selectors'

import CopyButtonHoc from 'components/HOC/CopyButtonHoc/CopyButtonHoc'

import Loader from 'components/Loader/Loader'
import Button from 'components/UIKit/Button/Button'

import { RequisitesWrapper } from '../RequisitesWrapper'

import './CryptoPayment.scss'

interface ICryptoPaymentProps {
  selectedCrypto: string
}

const b = block('crypto-payment')

export const CryptoPayment: React.FC<ICryptoPaymentProps> = ({ selectedCrypto }) => {
  const { closeModal } = useModalContext()

  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  const onClose = useCallback(() => {
    closeModal(MODAL_ROUTE_URLS.DEPOSIT())()
  }, [closeModal])

  return (
    <CryptoDeposit className={b()} selected={selectedCrypto}>
      {({ paymentData, isAgreed, communication, cryptoNotify, setIsAgreed }) => (
        <>
          {!isAgreed && (
            <>
              <div className={b('notify-wrapper')} dangerouslySetInnerHTML={cryptoNotify} />
              <Button text={locale.confirm} onClick={() => setIsAgreed(true)} className={b('confirm-button')} />
            </>
          )}
          {isAgreed && (
            <>
              <Loader loading={communication?.isLoading} colorType="dark" />
              {!communication?.isLoading && paymentData?.walletAddress && (
                <div className={b('payment-data')}>
                  <RequisitesWrapper
                    requisites={[{
                      name: locale.copyThisAddresOrScanQr, value: paymentData.walletAddress, isQrCode: false
                    }]}
                  />

                  <div className={b('minimum')}>
                    <span>{`${locale.minimumPaymentAmount}:`}</span>
                    <span>
                      {
                        `${paymentData.variables?.cryptoAmount} 
                          ${selectedCrypto} (≈${paymentData.variables?.fiatAmount} 
                          ${paymentData.variables?.fiatCurrency})
                        `}
                    </span>
                  </div>

                  <div className={b('warning')}>
                    {locale.transferAtLeast}
                    <span>{`${paymentData.variables?.cryptoAmount} ${selectedCrypto}`}</span>
                    {locale.toThisAccountWarning}
                  </div>

                  <div className={b('qr-container')}>
                    <QRCode value={paymentData.walletAddress} />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </CryptoDeposit>
  )
}
